import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  Typography,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import "@/components/membership/Dashboard/Dashboard.css";
import { THRESHOLD } from "@/constants/preview";

function ConfirmationModal({ open, handleClose, confirmFile, badFields }) {
  const [allowConfirm, setAllowConfirm] = useState(false);

  useEffect(() => {
    setAllowConfirm(false);
  }, [open]);

  const handleCloseClick = () => {
    handleClose();
  };

  const handleConfirmClick = () => {
    confirmFile();
    handleClose();
  };

  const handleInitialChange = (e) => {
    if (e.target.value.length > 1) {
      setAllowConfirm(true);
    } else {
      setAllowConfirm(false);
    }
  };

  return (
    <Box data-testid="are-you-sure-confirmation-modal">
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: "#ff000099" }}>
          Are You Sure?
        </DialogTitle>
        <DialogContent sx={{ paddingTop: "20px !important" }}>
          <DialogContentText>
            The file you&apos;re about to confirm shows a more than{" "}
            <b>{THRESHOLD}% change</b> in:
            <List sx={{ listStyleType: "disc", pl: 4 }}>
              {badFields?.map((field, index) => (
                <ListItem sx={{ display: "list-item" }} key={index}>
                  {field}
                </ListItem>
              ))}
            </List>
            <Typography>
              If this change is unexpected there&apos;s likely a problem with
              your file.
            </Typography>
            <Typography>
              <b>
                We strongly recommend double-checking that you have mapped the
                correct file.
              </b>
            </Typography>
            <Box
              sx={{
                marginTop: "8px",
                display: "flex",
                alignItems: "end",
              }}
            >
              <Typography>
                To confirm this file, please type your initials.
              </Typography>
              <TextField
                data-testid="confirm-this-sus-file"
                size="small"
                onChange={handleInitialChange}
                sx={{ marginLeft: "7px", width: "60px" }}
              />
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="siteBlueOutlined" onClick={handleCloseClick}>
            Let me take another look
          </Button>
          <Button
            className="siteRed"
            onClick={handleConfirmClick}
            disabled={!allowConfirm}
          >
            Yes, confirm this file
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

ConfirmationModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  confirmFlie: PropTypes.func,
};

export default ConfirmationModal;
